var exports = {
  "si": "VoiceSceneSeatHud.module__hud___YUZUaF",
  "Os": "VoiceSceneSeatHud.module__group___YUZUaF",
  "pG": "VoiceSceneSeatHud.module__caption___YUZUaF",
  "Tv": "VoiceSceneSeatHud.module__walkHint___YUZUaF",
  "p4": "VoiceSceneSeatHud.module__keyHint___YUZUaF",
  "Eb": "VoiceSceneSeatHud.module__key___YUZUaF",
};

module.exports = exports;
